import { ScopeHooks } from "sockapi/scope-specs";
import { getTeamScopeIdComponents } from "sockapi/scope-specs-util";
import { ScopeType } from "sockapi/scope-types";
import { ScopeTeamIdentifier } from "sockapi/scopes";

export const BLUE_THEATRE_CONFIG = {
  // puzReadable: "blue-theatre",
  puzName: "f4c9b812",
  minDay: 1,
  maxDay: 9,
};

export type TeamBlueTheatreDayState = {
  day: number;
};

export type TeamBlueTheatreScopeSpec = {
  identifier: ScopeTeamIdentifier;
  state: TeamBlueTheatreDayState;
  update: {
    day?: number;
  };
  step: {
    day?: number;
  };
  stepResponse: "";
  backendState: {
    day: number;
  };
};

export const teamBlueTheatreScopeHooks: ScopeHooks<ScopeType.TEAM_BLUE_THEATRE> =
  {
    identityFunc: (scope) => scope,
    getIdComponents: getTeamScopeIdComponents,
    update: (scopeState, payload) => {
      const { day } = payload;
      if (day !== undefined) scopeState.day = day;
    },
  };
